import React from 'react';
import { NextPage } from 'next';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Layout from '~/src/features/_layout';
import Agent from '~/src/features/agent';
import { initialProps } from '~/src/helpers/basePageFunc';


const AgentPage: NextPage = () => {
    const description = 'Официальное приложение Мой Дом.ру - это личный кабинет в вашем телефоне. ' +
        'Удобно оплачивайте услуги и управляйте договором. Доступно для скачивания в App Store и Google Play.';

    return (
        <Layout
            // @ts-ignore
            title='Скачать приложение Мой Дом.ру для оплаты услуг на Android и iOS'
            description={description}
            withMenu={true}
            withFooter={true}
            withChat={true}
            bgColor={COLORS.BgMain}
        >
            <Agent/>
        </Layout>
    );
};

AgentPage.getInitialProps = async(options) => {
    await initialProps(options);
    return ({});
};

export default AgentPage;
